import { TextField, Box, InputLabel } from "@mui/material";
import { useState, useRef, useEffect } from "react";

const plateCharacters = (value) => Array.from(String(value || '').toUpperCase())
  .slice(0, 6)
  .concat(Array(6).fill(''))
  .slice(0, 6);

const PlacaMotoInput = ({ onComplete, error, disabled, validationPlaca, defaultValue = '', resetKey }) => {
  const [plate, setPlate] = useState(() => plateCharacters(defaultValue)); // Inicializamos con seis elementos vacíos
  const inputsRef = useRef([]);

  const placeholders = ["A", "B", "C", "1", "2", "D"]; // Placeholders para cada posición de la placa

  useEffect(() => {
    setPlate(plateCharacters(defaultValue));
  }, [defaultValue, resetKey]);

  const handleChange = (index, event) => {
    let value = event.target.value.toUpperCase(); // Convertimos a mayúsculas

    // Validaciones según la posición en la placa
    if (index < 3) {
      value = value.replace(/[^A-Z]/g, ""); // Solo letras para los primeros tres caracteres
    } else if (index < 5) {
      value = value.replace(/[^0-9]/g, ""); // Solo números para los caracteres 4 y 5
    } else {
      value = value.replace(/[^A-Z]/g, ""); // Solo letras para el último carácter
    }

    const newPlate = [...plate];
    newPlate[index] = value;
    setPlate(newPlate);

    // Auto-focus al siguiente input si el valor es válido y no estamos en el último campo
    if (index < 5 && value !== "") {
      inputsRef.current[index + 1]?.focus();
    }

    // Llama a onComplete cuando todos los campos estén llenos
    if (newPlate.every((char) => char !== "")) {
      onComplete(newPlate.join(""));
    }
    if (validationPlaca !== undefined) {
      validationPlaca(newPlate.join(""));
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace" && !plate[index] && index > 0) {
      // Si el campo está vacío y el usuario presiona Backspace, mover al anterior
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handleFocus = (index) => {
    if (plate[index] === "") {
      inputsRef.current[index]?.focus();
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={1} marginBottom={2}>
      <InputLabel sx={{ fontWeight: 'bold' }}>PLACA:</InputLabel>
      <Box display="flex" gap={1}>
        {plate.map((char, index) => (
          <TextField
            key={index}
            inputRef={(el) => (inputsRef.current[index] = el)}
            value={char}
            onChange={(e) => handleChange(index, e)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onFocus={() => handleFocus(index)}
            variant="outlined"
            size="small"
            placeholder={placeholders[index]} // Placeholder dinámico
            inputProps={{
              maxLength: 1,
              style: {
                textAlign: "center",
                textTransform: index < 3 || index === 5 ? "uppercase" : "none",
                width: "2.5ch",
              },
            }}
            error={error}
            disabled={disabled}
          />
        ))}
      </Box>
    </Box>
  );
};

export default PlacaMotoInput;
